import React from 'react'
import NavAdmin from '../Components/AdminNav/NavAdmin'
import AddProducts from '../Components/AddProducts/AddProducts'
function AddProduct() {
  return (
    <div>
        <NavAdmin></NavAdmin>
        
        <AddProducts></AddProducts>
        
    </div>
  )
}

export default AddProduct